import http from "./httpService";

export default function addNewUserToNewsletter(data) {
  return http.post("/Site/SaveSubscribe", data);
}
